export default "__VITE_ASSET__DiweMJX1__"